/* eslint-disable react/jsx-handler-names */
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';

import MobileMenu from '../../MobileMenu';
import MobileMenuList from '../../MobileMenu/MobileMenuList';
import MobileMenuItem from '../../MobileMenu/MobileMenuItem';
import MobileMenuLink from '../../MobileMenu/MobileMenuLink';
import SeparatorRedesign from '../../MobileMenu/SeparatorRedesign';
import Logo from '../../../../base/Logo';
import LanguageSwitcher from '../../LanguageSwitcher';

import SupportCenter from '../../SupportCenter';

import { DSIcon } from '../../../../base';

import { useUserInfoContext } from '../../../context/UserInfoContext';

import HeaderNavMobileNotLogged from './HeaderNavMobileNotLogged';
import HeaderNavMobileLoggedIn from './HeaderNavMobileLoggedIn';

import styles from './HeaderNavMobileRedesign.module.scss';

const LoggedInInfo = ({ email, fullname }) => (
  <>
    <div>
      {trans('login.greeting', {
        name: fullname ? fullname.split(' ')[0] : ''
      })}
    </div>
    <div className={styles['header-nav-mobile__email']}>{email}</div>
  </>
);

const HeaderNavMobileRedesign = ({
  onClose = () => {},
  showLogin,
  changeCity = false
}) => {
  const { isUserLogged, userInfo } = useUserInfoContext();

  return (
    <MobileMenu
      logo={
        <a href={getPagePath('landing')}>
          <Logo size="small" />
        </a>
      }
      onClose={onClose}
      className={styles['header-nav-mobile__menu']}
      isRedesign
    >
      <MobileMenuList>
        <MobileMenuItem spaced className={styles['header-nav-mobile__title']}>
          {isUserLogged ? (
            <LoggedInInfo email={userInfo.email} fullname={userInfo.fullname} />
          ) : (
            trans('login.welcome')
          )}
        </MobileMenuItem>

        <MobileMenuItem spaced>
          <div>
            <SupportCenter
              backgroundColor="blue"
              photo="white"
              target="support"
              className={styles['header-nav-mobile__support-center']}
            />
          </div>
        </MobileMenuItem>

        <SeparatorRedesign />

        <MobileMenuItem>
          <MobileMenuLink className="ga-home" href={getPagePath('landing')}>
            <DSIcon name="home" /> {trans('landing-pages.home')}
          </MobileMenuLink>
        </MobileMenuItem>

        <MobileMenuItem>
          <MobileMenuLink
            className="publish-your-property-mobile"
            href={getPagePath('externals.landlord-landing')}
          >
            <DSIcon name="private_landlord" />{' '}
            {trans('landingpage.button.landlord')}
          </MobileMenuLink>
        </MobileMenuItem>

        <SeparatorRedesign />

        {showLogin &&
          (isUserLogged ? (
            <HeaderNavMobileLoggedIn changeCity={changeCity} />
          ) : (
            <HeaderNavMobileNotLogged changeCity={changeCity} />
          ))}

        <SeparatorRedesign />

        <MobileMenuItem>
          <MobileMenuLink>
            <DSIcon name="language" />
            <LanguageSwitcher theme="dark" />
          </MobileMenuLink>
        </MobileMenuItem>
        <SeparatorRedesign />
      </MobileMenuList>
    </MobileMenu>
  );
};

HeaderNavMobileRedesign.propTypes = {
  onClose: PropTypes.func,
  showLogin: PropTypes.bool.isRequired,
  changeCity: PropTypes.bool
};

export default HeaderNavMobileRedesign;
